import { render, staticRenderFns } from "./MemberQuestionsAnswered.vue?vue&type=template&id=4dc988f6&scoped=true&lang=pug&"
import script from "./MemberQuestionsAnswered.vue?vue&type=script&lang=js&"
export * from "./MemberQuestionsAnswered.vue?vue&type=script&lang=js&"
import style0 from "./MemberQuestionsAnswered.vue?vue&type=style&index=0&id=4dc988f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc988f6",
  null
  
)

export default component.exports